import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "agree-modal-comp" }
const _hoisted_2 = { class: "agree-content" }
const _hoisted_3 = { class: "terms-text" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "row-text" }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mv_button = _resolveComponent("mv-button")!
  const _component_mv_modal = _resolveComponent("mv-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mv_modal, { visible: _ctx.visible }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "content")
          ]),
          (_ctx.mode === 'agree')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_mv_button, {
                  class: "mb-16",
                  type: "round-primary",
                  text: "common.agree",
                  onClick: _ctx.actionAgree
                }, null, 8, ["onClick"]),
                _createElementVNode("div", {
                  class: "disagree-row",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.actionDisagree && _ctx.actionDisagree(...args)))
                }, [
                  _cache[1] || (_cache[1] = _createElementVNode("button", null, null, -1)),
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('common.disagree')), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_component_mv_button, {
                  class: "mb-16",
                  type: "round-primary",
                  text: "common.confirm",
                  onClick: _ctx.actionConfirm
                }, null, 8, ["onClick"])
              ]))
        ])
      ]),
      _: 3
    }, 8, ["visible"])
  ]))
}